import React, { useEffect, useState } from "react";
import { MdDelete, MdModeEditOutline } from "react-icons/md";
import "../../css/Admin-Awards/AdminAwardsCard.css";
import AdminEditAwards from "./AdminEditAwards";
import { toast } from "react-toastify";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";

const AdminAwardsCard = ({ data, fetchData,projectKey }) => {
  const [editProject, setEditProject] = useState(false);

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this Award?")) {
      try {
        await deleteDoc(doc(db, "awards", projectKey));
        toast.success("Award deleted successfully");
        fetchData();
      } catch (error) {
        toast.error("Failed to delete Award");
      }
    }
  };


  return (
    <div className="product-container">
      <div className="product-card">
        <div className="product-image-div">
          <img
            src={data.awardLogo}
            alt={data.awardLogo}
            className="product-image"
          />
        </div>
        <h1 className="product-name">{data.awardPosition}</h1>
        <p className="product-description">{data.awardName}</p>
        <div className="product-buttons">
          

          <div className="edit-button" onClick={() => setEditProject(true)}>
            <MdModeEditOutline style={{fontSize:'1.5rem' }}/>
          </div>

          <div className="delete-button" onClick={handleDelete}>
            <MdDelete style={{ fontSize: "1.5rem" ,color:"white"}} />
          </div>

        </div>
      </div>

      {editProject && (
                <AdminEditAwards onClose={() => setEditProject(false)} productData={data} fetchData={fetchData} projectKey={projectKey}/>
            )}
    </div>
  );
};

export default AdminAwardsCard;
